import script from "./ColorGradientBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorGradientBarChart.vue?vue&type=script&setup=true&lang=js"

import "./ColorGradientBarChart.vue?vue&type=style&index=0&id=2ce7cbdf&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce7cbdf"]])

export default __exports__